<template>
    <navigation />

    <promo-header>
        <h1>
            {{ $t("home.heading") }}
        </h1>
    </promo-header>

    <section class="section section-white">

        <div class="container">

            <h2 class="mb-4">
                {{ $t("languages.title") }}
            </h2>

            <h4 class="mb-4">
                {{ $t('languages.translatedSoFar', { translatedSoFar: 150 }) }}
            </h4>

            <p class="mb-4">
                <span class="badge bg-primary">T</span>
                {{ $t('languages.denotesTeachingNotes') }}

                <br />

                <span class="badge bg-primary">M</span>
                {{ $t('languages.denotesLessonMedia') }}
            </p>

            <div
                v-if="languages.length"
                class="table-responsive"
            >
                <table class="table table-striped table-bordered">
                    <thead>
                    <tr class="align-middle">
                        <th></th>

                        <th>
                            {{ $t("languages.english") }}
                        </th>

                        <th>
                            <select
                                name="language"
                                v-model="languageId"
                            >
                                <option :selected="! languageId">
                                    Select language...
                                </option>
                                <template v-for="language in languages">
                                    <option
                                        v-if="(language.id !== parseInt($app.translationEnglishId))"
                                        :value="language.id"
                                        :selected="(parseInt(languageId) === language.id)"
                                    >
                                        {{ language.name }}
                                    </option>
                                </template>
                            </select>
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="series in seriesList">
                        <td>
                            <a
                                v-if="$app.auth"
                                :href="`/series/${series.id}/`"
                                target="_blank"
                            >
                                {{ series.title }}
                            </a>
                            <template v-else>
                                {{ series.title }}
                            </template>

                            <span class="text-muted">
                                ({{ series.categories_list }})
                            </span>
                        </td>

                        <td>
                            <span
                                v-if="series.language_ids.includes(parseInt($app.translationEnglishId))"
                                class="badge bg-primary me-2"
                                data-toggle="tooltip"
                                :title="$t('languages.teacherNotes')"
                            >
                                T
                            </span>

                            <span
                                v-if="series.media_language_ids.includes(parseInt($app.translationEnglishId))"
                                class="badge bg-primary"
                                data-toggle="tooltip"
                                :title="$t('languages.lessonMedia')"
                            >
                                M
                            </span>
                        </td>

                        <td>
                            <template v-if="languageId">
                                <span
                                    v-if="series.language_ids.includes(parseInt(languageId))"
                                    class="badge bg-primary me-2"
                                    data-toggle="tooltip"
                                    :title="$t('languages.teacherNotes')"
                                >
                                    T
                                </span>

                                <span
                                    v-if="series.media_language_ids.includes(parseInt(languageId))"
                                    class="badge bg-primary"
                                    data-toggle="tooltip"
                                    :title="$t('languages.lessonMedia')"
                                >
                                    M
                                </span>
                            </template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </section>

    <site-footer />
</template>

<script>
import PromoHeader from "../partials/PromoHeader.vue";
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";

export default {
    name: "MaterialLanguages",

    components: {
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    data() {
        return {
            languageId: null,
            languages: [],
            seriesList: [],
        };
    },

    mounted() {
        axios.get("/api/languages")
            .then((response) => {
                this.languages = response.data;
            });

        axios.get("/api/series/all")
            .then((response) => {
                this.seriesList = response.data;
            });
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("languages.title")}`,
        };
    },
};
</script>
